import Trans from "util/Trans";

const EmptyTrickList = () => {
  return (

    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '70vh',
        textAlign: 'center',
        padding: '20px',
      }}
    >
      <h2
        style={{
          color: 'white',
          marginBottom: '10px',
          fontSize: '24px',
        }}
      >
        <Trans i18nKey="NO_TRICKS_FOUND">Keine Runs gefunden</Trans>
      </h2>
      <p
        style={{
          color: 'white',
          fontSize: '16px',
          maxWidth: '300px',
          lineHeight: '1.5',
        }}
      >
        <Trans i18nKey="ALIEN_LOOKING_FOR_SKATEBOARD">
          Klick auf das Auge um deine Runs der Welt zu zeigen.
        </Trans>
      </p>
    </div>
  )
}
export default EmptyTrickList;
